import React from 'react'
import './Global_education.css'
import Common_title from '../../common_components/common-title/Common_title'

const Global_education = () => {

    const cityImages = [
        { name: 'Mumbai', imgSrc: '/assets/images/home/global-education/mumbai.png' },
        { name: 'Delhi', imgSrc: '/assets/images/home/global-education/delhi.png' },
        { name: 'Hyderabad', imgSrc: '/assets/images/home/global-education/hyderabad.png' },
        { name: 'Bengaluru', imgSrc: '/assets/images/home/global-education/bengaluri.png' },

    ];

    return (
        <>
            <section className='Global_education_section'>
                <div className='container-lg'>
                    <div className='banner_bg'>
                        <Common_title className='text-center' title='Global Education Experience' subtitle='Learn Across Multiple Cities' />

                        <div className='all_cards'>
                            <div className='row'>
                                {cityImages.map((data, index) => (
                                    <div className='col-md-3  col-6 mb-4'>
                                        <div className='city_card'>
                                            <div className='img_div'>
                                                <img className='city_img' src={process.env.PUBLIC_URL + data.imgSrc} />
                                            </div>
                                            <p className='cityname'>{data.name}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Global_education